import React, { useCallback, useEffect, useState } from 'react';

import { ResetLocationIcon } from 'features/store/pages/pickup-store-selector/components/reset-location-button/reset-location-icon';

import { GeolocationDeniedModal } from 'components/geolocation-denied-modal';
import { ResetLocationAnimation } from 'components/lottie-animations/reset-location/reset-location';
import { useGeolocation } from 'state/geolocation';
import { t } from 'state/intl/translations';

import { Button } from './reset-location-button.styled';
import { IResetLocationButtonProps } from './types';

export const ResetLocationButton: React.FC<React.PropsWithChildren<IResetLocationButtonProps>> = ({
  onButtonPress,
  loading,
}) => {
  const {
    isPermissionGranted,
    isPermissionPrompt,
    isPermissionDenied,
    setPermissionChecking,
    loadingUserCoordinates,
  } = useGeolocation();

  const [geolocationDeniedModalOpen, setGeolocationDeniedModalOpen] = useState(false);

  const dismissModal = () => setGeolocationDeniedModalOpen(false);

  const handlePress = useCallback(() => {
    if (isPermissionDenied) {
      setGeolocationDeniedModalOpen(true);
    } else if (isPermissionPrompt) {
      setPermissionChecking();
    }

    onButtonPress();
  }, [isPermissionDenied, isPermissionPrompt, onButtonPress, setPermissionChecking]);

  const getStartIcon = () => {
    if (loading || loadingUserCoordinates) {
      return <ResetLocationAnimation />;
    }

    return <ResetLocationIcon />;
  };

  useEffect(() => {
    if (isPermissionGranted) {
      setGeolocationDeniedModalOpen(false);
    }
  }, [isPermissionGranted]);

  return (
    <>
      <GeolocationDeniedModal isOpen={geolocationDeniedModalOpen} dismissModal={dismissModal} />
      <Button
        variant="unstyled"
        size="md"
        accessibilityLabel={t('resetLocationButtonAria')}
        testID="reset-location-button"
        onPress={handlePress}
        isDisabled={loading}
        icon={getStartIcon()}
      />
    </>
  );
};
